import { Box } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetParamsValue,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../../redux/actions/sidebarActions";
import LoanDrilldownButtonSidebarAdd from "../../../buttons/LoanDrilldownButtonSidebarAdd";
import OriginatorFeesTable from "../tables/OriginatorFeesTable";

const ITEM_NAME = "Correspondent Fee";
const SIDEBAR_TYPE = loanDrilldownSidebarTypes.ADD_EDIT_CORRESPONDENT_FEE;
const LoanFeesSubTabCorrespondentFees = () => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const dispatch = useDispatch();

  const rowData = useMemo(
    () => loanTerms?.correspondentFees || [],
    [loanTerms?.correspondentFees]
  );
  const headerSubtitle = useMemo(() => {
    if (isEmpty(rowData)) {
      return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
    }
    return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
  }, [rowData]);

  const onRowClicked = useCallback(
    (d) => {
      dispatch(sidebarTypeSet(SIDEBAR_TYPE));
      dispatch(sidebarSetParamsValue(null));
      dispatch(sidebarSetStateValue(d));
    },
    [SIDEBAR_TYPE]
  );

  return (
    <PrimaryContentCard
      maxWidth="lg"
      title={ITEM_NAME + "s"}
      subTitle={headerSubtitle}
      endContent={
        <LoanDrilldownButtonSidebarAdd type={SIDEBAR_TYPE}>
          Add {ITEM_NAME}
        </LoanDrilldownButtonSidebarAdd>
      }
      loading={isNil(loanTerms)}
      // cardSx={{ pb: 0 }}
    >
      <SectionCard sx={{ p: 0, overflow: "hidden" }}>
        <OriginatorFeesTable onRowClicked={onRowClicked} rowData={rowData} />
      </SectionCard>
    </PrimaryContentCard>
  );
};

/**
 * COMPONENTS
 */

const SectionCard = ({ children, grey = false, sx }) => {
  const styles = useMemo(() => {
    return {
      py: 4,
      px: 3,
      borderRadius: 2,
      border: `1px solid #e5e7eb`,
      ...sx,
    };
  }, [sx]);

  if (grey) {
    return <GreyCard sx={styles}>{children}</GreyCard>;
  }
  return <Box sx={styles}>{children}</Box>;
};

const GreyCard = ({ children, sx }) => {
  return (
    <Box
      sx={{
        border: `1px solid #e5e7eb`,
        background: "#f9fafb",
        borderRadius: 2,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
export default LoanFeesSubTabCorrespondentFees;
